import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { breakpoints, spacing } from '../../../utils/styleguide';
import PrimaryButton from '../buttons/PrimaryButton';
import { ImageStyleProps } from '../../contentful-elements/Image';
import Typography from '../text/Typography';
import PropsComponent from '../types/PropsComponent';
import ButtonPromptWrapper from '../ButtonPromptWrapper';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;

  *:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.div`
  margin-bottom: ${spacing[3]}px;
  ${breakpoints.desktop} {
    margin-bottom: ${spacing[4]}px;
  }
`;

const ImageWrapper = styled.div`
  width: 70%;
  ${breakpoints.desktop} {
    margin-bottom: ${spacing[6]}px;
  }
`;

const Description = styled(Typography)`
  margin-bottom: ${spacing[5]}px;
`;

const ButtonWrapper = styled(ButtonPromptWrapper)`
  margin: ${spacing[2]}px 0;
`;

type BuildingBlockInfoProps = {
  title?: ReactNode;
  content?: ReactNode;
  description?: ReactNode;
  buttonLabel?: string;
  buttonPrompt?: string;
  buttonColor?: 'onYellow' | 'onDark' | 'onLight';
  largeButton?: boolean;
  href?: string;
  Logo?: PropsComponent<ImageStyleProps>;
  className?: string;
};

function BuildingBlockInfo({
  title,
  content,
  description,
  buttonLabel,
  buttonPrompt,
  buttonColor = 'onLight',
  largeButton,
  href,
  Logo,
  className,
}: BuildingBlockInfoProps) {
  return (
    <Wrapper className={className}>
      <Title>{title}</Title>
      <Description variant="body" tag="div">
        {description}
      </Description>
      {content}
      {buttonLabel && (
        <ButtonWrapper prompt={buttonPrompt}>
          <PrimaryButton
            color={buttonColor}
            label={buttonLabel}
            tag="a"
            href={href}
            size={largeButton ? 'large' : 'small'}
          />
        </ButtonWrapper>
      )}
      {Logo && (
        <ImageWrapper>
          <Logo
            css={css`
              max-width: 100%;
              width: 100%;
            `}
          />
        </ImageWrapper>
      )}
    </Wrapper>
  );
}

export default BuildingBlockInfo;
